import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Helmet } from 'react-helmet';
import './Weekbyweek.css';
// import './dom-to-image.min.js';
import * as actions from '../Actions';
import { fetchInitialData } from "../../fetchData";
import Right from '../../right/Right';
import Service from '../../service/Service';
import WeekSlider from '../common/WeekSlider';
import ShareIcon from '../common/ShareIcon';
// import domtoimage from 'dom-to-image';

const service = new Service();

let window_width = 1024;
class Weekbyweek extends Component {
    constructor(props) {
        super(props);
        let initialData = [];
        let currentweek=0,image;
        if (__isBrowser__ && window.__initialData__ && window.__initialData__['initialData'] && window.__initialData__['initialData']['result']) {
            initialData = window.__initialData__['initialData']['result'];
            delete window.__initialData__;
        } else {
            if (props.staticContext && props.staticContext.initialData && props.staticContext.initialData['initialData'] && props.staticContext.initialData['initialData']['result']) {
                initialData = props.staticContext.initialData['initialData']['result'];
                currentweek = initialData['currentWeek'];
                image= initialData['images'][initialData['currentWeek']-1]['twodscan'];
            }
        }
        if (initialData && initialData['currentWeek']) {
            currentweek = initialData.currentWeek;
        }
        this.state = {
            initialData: initialData,
            WeekByweekdata: [],
            currentweek:parseInt(currentweek),
            image:image,
            image_2d: '',
            image_3d: '',
            clickwedWeek: 1,
            scrollwidth: '',
            halfwidth: '',
            weekwd: '',
            weeks: '',
            IsExpected: false,
            window_width: window_width,
        }
    }

    static initialAction(reqUrl, ftk, authData, uId, childData) {
        var header = {
            'Content-Type': 'application/json',
            'ftk': global.ftk,
            'uid': global.uID,
            'access-token': global.accessToken,
            'user-agent': global.userAgent,
            'isdesktop': global.isdesktop
        }
        var url = global.api_url + "weekfetus/getweekbyweekfetusdevelopmentimages";
        let body = JSON.stringify({})
        return fetchInitialData(url, JSON.stringify(header), body);
    }

    componentDidMount() {
        document.addEventListener("click", actions.domClick);
        console.log("initialData",this.state.image);
        if (this.state.currentweek > 1) {
            this.setState({ IsExpected: true });
        } else {
            this.setState({ IsExpected: false });
        }
        if (navigator.onLine) {
            if (!this.state.initialData || (this.state.initialData && this.state.initialData.length < 1)) {
                service.showLoader();
                this.getWeekByWeekImages();
            } else {
                localStorage.setItem('WeekByWeekData', JSON.stringify(this.state.initialData));
                this.weekbyweeklanding();
                this.loadStateData();
            }
        } else {
            if (localStorage.getItem('WeekByWeekData')) {
                this.setState({ initialData: JSON.parse(localStorage.getItem('WeekByWeekData')) });
                this.weekbyweeklanding();
                this.loadStateData();
            }
            service.hideLoader();
        }

        this.setState({window_width : window.innerWidth});
    }

    componentWillUnmount() {
        document.removeEventListener("click", actions.domClick);
       
    }

    loadStateData() {
        setTimeout(() => {
            try {
                this.state.scrollwidth = document.querySelector('.week-by-week').offsetWidth;
                this.state.halfwidth = this.state.scrollwidth / 2;
                this.state.weekwd = document.querySelector('.week-bar li').offsetWidth;
                this.state.weeks = document.querySelectorAll('.week-bar li');
                let a;
                for (let j = 1; j <= document.querySelectorAll('.week-bar li').length; j++) {
                    let wd = j * this.state.weekwd;
                    if (wd > this.state.halfwidth) {
                        a = j - 1;
                        break
                    }
                }
                for (let i = 0; i <= document.querySelectorAll('.week-bar li').length; i++) {
                    if (this.state.weeks[i].classList.contains('sel-week')) {
                        document.querySelector('.weeks-section').scrollLeft = ((this.state.weekwd * (i - a)));
                        break
                    }
                }

            } catch (err) {
                return "";
            }
            service.loadImages();
        }, 50)
    }

    getWeekByWeekImages() {
        var postData = {}
        var url = global.api_ci_url + "WeekByWeek/getWeekByWeekImages";
        service.postServiceCall(url, postData).then((json) => {
            if (json['result']) {
                this.setState({ initialData: json['result'],
                currentweek: json['result']['currentWeek'],
                image:json['result']['images'][json['result']['currentWeek']-1]['twodscan'] }, () => { this.weekbyweeklanding(); this.loadStateData(); });
                localStorage.setItem('WeekByWeekData', JSON.stringify(json['result']));
            }
            service.hideLoader();
        }).catch((error) => {
            console.error(error);
            service.hideLoader();
        });
    }

    weekbyweeklanding() {
        try {
            if (Object.keys(this.state.initialData).length > 0) {
                let ary = this.state.initialData;
                const currentweekId = ary.currentWeek - 1;
                if (ary['images']) {
                    this.setState({ WeekByweekdata: ary['images'] });
                }
                if(this.state.IsExpected!="true"){
                    this.setState({ currentweek: ary['currentWeek'] });
                }else{
                    this.setState({ currentweek: 1 });
                }
                this.setState({ image: ary.images[currentweekId].twodscan });
            }
            this.loadweekbyweekTracker();
            service.hideLoader();
            service.loadImages();
        } catch (error) {
            console.error(error);
            service.hideLoader();
        }

    }
    loadweekbyweekTracker() {
        if (!global.ftk || global.ftk == "") {
            setTimeout(() => {
                actions.weekInfo(this.state.currentweek, this, 1, 'wbw');
            }, 50)
        } else {
            setTimeout(() => {
                console.log("loadweekbyweekTracker====>",this.state.currentweek);
                let shadesli = document.querySelector('#week_' + this.state.currentweek);
                if (shadesli) {
                    // shadesli.classList.remove('sel-week');
                    if (shadesli.firstChild && shadesli.firstChild.children) {
                        actions.weekInfo(this.state.currentweek, this, 1, 'wbw');
                    }
                }
            }, 50)
        }
    }
    selectimage(weekno, str) {
        if (this.state.WeekByweekdata) {
            this.setState({ clickwedWeek: weekno })
            let shadesEl1 = document.querySelector('.scan_2D');
            let shadesEl2 = document.querySelector('.scan_3D');
            let shadesEl3 = document.querySelector('.scan_img');
            shadesEl3.classList.contains('scan_img');

            (weekno == "undefined" || weekno == "") ? weekno = weekno : weekno = weekno;
            if (this.state.WeekByweekdata[weekno - 1]) {
                return (
                    str == "scan_3D" ? (this.setState({ image: this.state.WeekByweekdata[weekno - 1].threedscan }),
                        shadesEl2.classList.add('selectedimg'), shadesEl1.classList.remove('selectedimg'), shadesEl3.classList.remove('selectedimg'))
                        : str == "imageTab" ? (this.setState({ image: this.state.WeekByweekdata[weekno - 1].image }),
                            shadesEl3.classList.add('selectedimg'), shadesEl1.classList.remove('selectedimg')
                            , shadesEl2.classList.remove('selectedimg')) :
                            (this.setState({ image: this.state.WeekByweekdata[weekno - 1].twodscan }), shadesEl1.classList.add('selectedimg'),
                                shadesEl3.classList.remove('selectedimg'), shadesEl2.classList.remove('selectedimg'))
                )
            }
        }
    }
    // shareContent(id){

    // var node = document.querySelector('.weekbyweek_cont');

    // domtoimage.toPng(node)
    //     .then(function (dataUrl) {
    //         var img = new Image();
    //         img.src = dataUrl;
    //         var a=document.body.appendChild(img);
    //         console.log("image====>",img.src);
    //         console.log("image====>",a);

    //     })
    //     .catch(function (error) {
    //         console.error('oops, something went wrong!', error);
    //     });
    // domtoimage.toJpeg(document.querySelector('.weekbyweek_cont'), { quality: 0.95 })
    // .then(function (dataUrl) {
    //     var link = document.createElement('a');
    //     link.download = 'my-image-name.jpeg';
    //     link.href = dataUrl;
    //     link.click();
    //     console.log("link====>",link);
    //     // console.log("link====>",link);
    //     console.log("link====>",link.href);

    // });
    // }
    shareIcon(id) {
        console.log("shareOn================>",id.target.parentNode);
        if(document.querySelector('.sharing-options').style.display!="block"){
            document.querySelector('.sharing-options').style.display="block";
        }else{
            document.querySelector('.sharing-options').style.display="none";
        }
        if (window.innerWidth < 767) {
            document.getElementsByClassName('share-overlay')[0].style.display = 'block';
        }
    }
    shareTemplate(id,shareoption,imageUrl){
        // console.log("shareTemplate====>",shareoption);
        //  var node = document.querySelector('.weekbyweek_cont');

        // domtoimage.toPng(node)
        //     .then(function (dataUrl) {
        //         var img = new Image();
        //         img.src = dataUrl;
        //         var a=document.body.appendChild(img);
        //         console.log("image====>",img.src);
        //         console.log("image====>",a);

        //     })
        //     .catch(function (error) {
        //         console.error('oops, something went wrong!', error);
        //     });
        if (global.ftk != "") {
            console.log("non login");
            if (shareoption == "facebook" || shareoption == "whatsapp") {
                document.querySelector("meta[property='og\\:description']").content = "Check out this helpful week-byweek guide to pregnancy so you know exactly what to expect in your " + id + " weeks of pregnancy.";
                document.querySelector("meta[property='og\\:image']").content = imageUrl;

            } else if (shareoption == "twitter" || shareoption == "pintrest") {
                document.querySelector("meta[property='twitter\\:description']").content = "Check out this helpful week-byweek guide to pregnancy so you know exactly what to expect in your " + id + " weeks of pregnancy.";
                document.querySelector("meta[property='twitter\\:image']").content = imageUrl;
                document.querySelector("meta[property='twitter\\:title']").content = "PARENTING.FIRSTCRY.AE";
            }
            actions.shareArticle(shareoption, global.currentURL);
        } else {
            console.log("non login========>1");
            service.showAlert("Please Login");
            window.location.href = global.loginUrl + '?URL=' + global.currentURL;
            return false;
        }
    }
    render() {
        var windowWidth = this.state.window_width;
        return (
            <main className="main-container week-by-week-cont">
                <Helmet
                    title="Pregnancy Week by Week Pictures of Baby - FirstCry Parenting"
                    meta={[
                        { "name": "description", "content": "Select your specific week and ultrasound 2D & 3D images to get a detailed description of how your baby is developing or see how your baby is growing with our week by week pregnancy pictures tool." },
                        { "name": "keywords", "content": "week by week pregnancy images" },
                        { "name": "atdlayout", "content": "tools_sp" },
                        { "property": "og:locale", "content": "en_US" },
                        { "property": "og:type", "content": "website" },
                        { "property": "og:title", "content": "PARENTING.FIRSTCRY.AE" },
                        { "property": "og:description", "content": "Check out this helpful week-byweek guide to pregnancy so you know exactly what to expect in your " + this.state.currentweek + " weeks of pregnancy." },
                        { "property": "og:url", "content": global.currentURL },
                        { "property": "og:image", "content": this.state.image },
                        { "property": "twitter:image", "content": this.state.image },
                        { "property": "twitter:title", "content": "PARENTING.FIRSTCRY.AE" },
                        { "property": "twitter:description", "content": "Check out this helpful week-byweek guide to pregnancy so you know exactly what to expect in your " + this.state.currentweek + " weeks of pregnancy." }
                    ]}
                />
                <div className="title">
                    <div className="breadcrumb R11_9e">
                        <span><Link to={service.getRedirectUrl("/")} className="R11_9e">Home</Link></span>
                        <span className="R11_9e breadcrum_icon" data-icon-font="l"></span>
                        <span><Link to={service.getRedirectUrl("/tools")} className="R11_9e">Tools</Link></span>
                        <span className="R11_9e breadcrum_icon" data-icon-font="l"></span>
                        <span>Pregnancy Week by Week</span>
                    </div>
                    {/* <h1 className="B24_00">Fetal Development Week by Week Images </h1> */}
                </div>

                <div className="fetalvideo-head">
                    {
                        (windowWidth < 767) ? 
                        (<div className="mobile_listing">
                            <Link to={service.getRedirectUrl(`/tools`)} title=""><span className="icon" data-icon-font="s"></span></Link>
                        
                            <h1 className="M15_pink">Fetal Development Week by Week Images </h1>
                        </div>) :
                        (<div className="mobile_listing">
                            <h1 className="B24_00">Fetal Development Week by Week Images</h1>
                        </div>)
                    }
                </div>
                <div className="sub-container left">
                    <div className="week-by-week data-container left">
                        <div className="baby-size-weeks">
                            <WeekSlider eleRef={this} WeekBdata={this.state.WeekByweekdata} weekKey={'week'} keyVal={1} tool={'wbw'} />
                        </div>
                        <div className="weekbyweek_cont">
                            <div className='weekbyweek for_2d'>
                                <section className="tabs_cont">
                                    <div className="scan_2D selectedimg" onClick={() => { this.selectimage(this.state.clickwedWeek, "scan_2D") }}>
                                        <span className="M14_42 dev2Dscan">2D Scan</span>
                                    </div>
                                    <div className="scan_3D" onClick={() => { this.selectimage(this.state.clickwedWeek, "scan_3D") }}>
                                        <span className="M14_9e dev3Dscan">3D Scan</span>
                                    </div>
                                    <div className="scan_img" onClick={() => { this.selectimage(this.state.clickwedWeek, "imageTab") }}>
                                        <span className="M14_9e devscanimg">Image</span>
                                    </div>
                                </section>
                                <section className="view_image 2d_image">
                                {/* {`${this.state.image}`.replace(/\.jpg$/i, ".webp")} */}
                                    <img className="ga-img" src={`${this.state.image}`.replace(/\.jpg$/i, ".webp")} alt="" title="" />
                                </section>
                            </div>
                        </div>
                        <ShareIcon eleRef={this} tool={'wbw'}/>
                    <div className="share-overlay"></div>
                    </div>
                </div>
                <Right url={this.props.match.url} />
            </main>
        )
    }
}

export default Weekbyweek;



// WEBPACK FOOTER //
// src/shared/tools/week-by-week/Weekbyweek.js